import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_storage_laundry: FaireCategoryEntity = {
  token: "cat_storage-laundry",
  type: "category",
  name: "Laundry & hampers",
  level: 3,
  parentToken: "cat_home-decor-storage",
  href: "/category/home-decor/storage-organization/laundry-hampers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
